import React from 'react'
import { Helmet } from 'react-helmet'
import metaData from './../../data/metaData.json'


const createTitle = carId => {
    return metaData[carId].title
}

const createDescription = carId => {
    return metaData[carId].description
}

export const PageWrapper = ({ carId="default", children, ...props }) => {
    return (
        <>
            <Helmet>
                <title>{createTitle(carId)}</title>
                <meta name="description" content={createDescription(carId)} />
            </Helmet>
            {
                children
            }
        </>
    )
}